var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDdMessageBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10001 4H19.1C19.7 4 20.1 4.4 20.1 5V19C20.1 19.6 19.7 20 19.1 20H5.10001C4.50001 20 4.10001 19.6 4.10001 19V5C4.10001 4.4 4.50001 4 5.10001 4Z",
    fill: "#BDEFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 14V5C22.1 3.3 20.8 2 19.1 2H5.10001C3.40001 2 2.10001 3.3 2.10001 5V19C2.10001 20.7 3.40001 22 5.10001 22H19.1C20.8 22 22.1 20.7 22.1 19V14ZM5.10001 4H19.1C19.7 4 20.1 4.4 20.1 5V13H17.6C16.9 13 16.3 13.3 15.9 13.9L14.5 16H9.60001L8.20001 13.9C7.80001 13.3 7.20001 13 6.50001 13H4.10001V5C4.10001 4.4 4.50001 4 5.10001 4Z",
    fill: "#49BEFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDdMessageBox);
export default __webpack_public_path__ + "static/media/icon-dd-message-box.73e10f3e7d9629da7c903404e7d7242d.svg";
export { ForwardRef as ReactComponent };